import { highlightSelectionMatches, search } from "@codemirror/search";
import { Extension } from "@codemirror/state";
import { EditorView } from "codemirror";
import ReactDOM from "react-dom/client";

import SearchPanel from "../SearchPanel/SearchPanel";
import { buildFireboltSqlExtensions } from "../dialect/dialect";
import { SQLynxExtensions } from "./sqlynx_extension";
import {
  StatementGutterMarkerDecorator,
  StatementGutterMarkerState,
} from "./statementGutter/statementGutterMarker";

export const editorExtensions: Extension[] = [
  search({
    top: true,
    caseSensitive: true,
    createPanel: (view: EditorView) => {
      const dom = window.document.createElement("div");
      const root = ReactDOM.createRoot(dom);
      root.render(<SearchPanel view={view} />);
      const panel: {
        dom: HTMLElement;
        top?: boolean;
        destroy?: () => void;
      } = {
        dom,
        top: true,
        destroy: () => {
          const doUnmount = () => {
            try {
              root.unmount();
            } finally {
              try {
                dom.remove();
              } catch {
                console.warn("Failed to remove search panel DOM node");
              }
            }
          };
          try {
            if (typeof queueMicrotask === "function") {
              queueMicrotask(doUnmount);
            } else if (typeof requestAnimationFrame === "function") {
              requestAnimationFrame(() => doUnmount());
            } else {
              setTimeout(doUnmount, 0);
            }
          } catch {
            setTimeout(doUnmount, 0);
          }
        },
      };
      return panel;
    },
  }),
  SQLynxExtensions,
  StatementGutterMarkerState,
  StatementGutterMarkerDecorator,
  ...buildFireboltSqlExtensions(),

  highlightSelectionMatches({
    maxMatches: 500,
  }),
  EditorView.scrollMargins.of(() => {
    return {
      right: 48,
    };
  }),
];
